import { render, staticRenderFns } from "./MessageResult.vue?vue&type=template&id=dbfe2b9a&scoped=true"
import script from "./MessageResult.vue?vue&type=script&lang=js"
export * from "./MessageResult.vue?vue&type=script&lang=js"
import style0 from "./MessageResult.vue?vue&type=style&index=0&id=dbfe2b9a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfe2b9a",
  null
  
)

export default component.exports